import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SecurityVerificationModal = ({ isOpen, onClose, onVerify, amount }) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (verificationCode === '123456') {
      onVerify();
      onClose();
    } else {
      setError('Invalid verification code. Please try again.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-[var(--color-card)] rounded-lg shadow-xl w-full max-w-md">
        <div className="p-4 md:p-6 border-b border-[var(--color-border)]">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[var(--color-warning)] bg-opacity-10 flex items-center justify-center">
                <Icon name="ShieldAlert" size={20} color="var(--color-warning)" />
              </div>
              <h2 className="text-lg md:text-xl font-semibold text-[var(--color-foreground)]">
                Security Verification
              </h2>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              iconName="X"
              iconSize={20}
            />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4">
          <div className="p-4 bg-[var(--color-warning)] bg-opacity-10 rounded-lg border border-[var(--color-warning)] border-opacity-20">
            <div className="flex items-start gap-3">
              <Icon name="AlertTriangle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-semibold text-[var(--color-foreground)] mb-1">
                  Large Transaction Detected
                </p>
                <p className="text-xs text-[var(--color-muted-foreground)]">
                  For your security, we need to verify this ${amount?.toLocaleString()} transaction. A verification code has been sent to your registered email and phone number.
                </p>
              </div>
            </div>
          </div>

          <Input
            label="Verification Code"
            type="text"
            placeholder="Enter 6-digit code"
            value={verificationCode}
            onChange={(e) => {
              setVerificationCode(e?.target?.value);
              setError('');
            }}
            error={error}
            required
            maxLength={6}
          />

          <div className="p-3 bg-[var(--color-muted)] rounded-lg">
            <div className="flex items-start gap-2">
              <Icon name="Info" size={16} color="var(--color-muted-foreground)" className="mt-0.5 flex-shrink-0" />
              <p className="text-xs text-[var(--color-muted-foreground)]">
                Mock verification code: <span className="font-semibold">123456</span>
              </p>
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              fullWidth
            >
              Verify
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SecurityVerificationModal;